<template>
    <div class="content-page">
        <div class="bd">
            <div class="tab-header">
                <div class="header-left">
                    <el-button type="primary" size="small" @click="addPrinter">新建打印规则</el-button>
                    <el-tooltip placement="bottom" effect="light">
                        <div slot="content">开启后，通过建立不同分单规则，应用于不同场景，如设定指定商品分组、自定义打印机打印分单小票等。</div>
                        <div class="switch-container">
                            <span>打印分单小票</span>
                            <el-switch
                                v-model="printSplit"
                                active-color="#67c23a"
                                inactive-color="#f57878"
                                @change="modifyPrintSplit"
                            ></el-switch>
                        </div>
                    </el-tooltip>
                </div>
            </div>
            <div class="tab-content">
                <el-tabs v-model="activeName" type="card">
                    <el-tab-pane
                        v-for="(item, index) in pathList"
                        :key="String(item.path)"
                        :label="item.name"
                        :name="String(index)"
                    ></el-tab-pane>
                </el-tabs>
                <div class="list">
                    <el-table :data="printRuleList" style="width: 100%;">
                        <el-table-column label="打印机规则名称">
                            <template slot-scope="scope">
                                <div
                                    class="name"
                                >{{scope.row.printRuleName}}-{{scope.row.autoPrint ? '自动打印' : '手动打印'}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="设备备注名称/型号">
                            <template slot-scope="scope">
                                <div class="item-count">{{scope.row.printDeviceNames}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" header-align="right">
                            <template slot-scope="scope">
                                <div class="float-right">
                                    <el-button
                                        size="small"
                                        type="primary"
                                        @click="edit(scope.$index)"
                                        plain
                                    >编辑</el-button>
                                    <el-button
                                        size="small"
                                        type="danger"
                                        @click="del(scope.row.printRuleId)"
                                        plain
                                    >删除</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-size="pageSize"
                        background
                        layout="prev, pager, next, jumper"
                        :total="count"
                    ></el-pagination>
                </div>
            </div>
        </div>
        <el-dialog
            :visible.sync="dialogAddRuleVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="510px"
            @close="addRuleDialogClose"
        >
            <div
                slot="title"
                class="dialog-title"
            >{{addRuleForm.printRuleId ? '编辑分票打印规则':'新增分票打印规则'}}</div>
            <el-form
                :model="addRuleForm"
                :rules="addRuleFormRule"
                ref="addRuleForm"
                label-width="108px"
                class="demo-ruleForm"
                :hide-required-asterisk="true"
            >
                <el-form-item label="打印规则名称" prop="printRuleName">
                    <el-input v-model="addRuleForm.printRuleName" placeholder="请填写打印规则名称"></el-input>
                </el-form-item>
                <el-form-item label="关联小票规则" prop="relationPrintRuleId">
                    <el-select v-model="addRuleForm.relationPrintRuleId" placeholder="请选择打印模板">
                        <el-option
                            v-for="(item, index) in templateList"
                            :key="index"
                            :label="`${item.printRuleName}-${item.autoPrint ? '自动打印' : '手动打印'}`"
                            :value="Number(item.printRuleId)"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="打印场景">
                    <el-radio-group v-model="addRuleForm.printStage">
                        <el-radio :label="1">前台打印</el-radio>
                        <el-radio :label="2">厨房打印</el-radio>
                        <el-radio :label="3">加菜打印</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="打印商品" prop="goodsCategorys">
                    <el-cascader
                        placeholder="请选择打印商品"
                        v-model="addRuleForm.goodsCategorys"
                        :options="classifyList"
                        :props="{ multiple: true}"
                        filterable
                    ></el-cascader>
                </el-form-item>
                <el-form-item label="打印设备" prop="printDevices">
                    <el-select
                        v-model="addRuleForm.printDevices"
                        multiple
                        filterable
                        allow-create
                        default-first-option
                        placeholder="请选择打印设备"
                    >
                        <el-option
                            v-for="item in printerDeviceList"
                            :key="item.printerDevicesId"
                            :label="`${item.deviceName} ${deviceType[item.deviceType-1]}`"
                            :value="item.printerDevicesId"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="save" :loading="isSubmit">保存</el-button>
                <el-button @click="dialogAddRuleVisible = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    getPrintRules,
    getCountPrintRules,
    getPrinterDevices,
    getEdcShopGoodsCategorys,
    savePrintRule,
    delPrintRule,
    toSetPrintType,
    getShopInfo
} from "@/api/index.js";
import { mapState } from "vuex";
export default {
    data() {
        return {
            pathList: [
                {
                    name: "普通小票",
                    path: "/setting/print/normal"
                },
                {
                    name: "分单小票",
                    path: "/setting/print/split"
                }
            ],
            templateList: [
                {
                    name: "堂食模板",
                    id: "1"
                },
                {
                    name: "外卖模板",
                    id: "2"
                }
            ],
            printRuleList: [],
            printerDeviceList: [],
            deviceType: ["云打印机", "PC本地打印机", "APP本地打印机"],
            activeName: "1",
            count: 0,
            pageSize: 5,
            dialogAddRuleVisible: false,
            addRuleForm: {
                relationPrintRuleId: "",
                printRuleName: "",
                goodsCategorys: [],
                printDevices: [],
                printType: 2,
                printPageNum: 1,
                printStage: 1
            },
            addRuleFormRule: {
                printRuleName: [
                    {
                        required: true,
                        message: "请填写打印规则名称",
                        trigger: "blur"
                    }
                ],
                relationPrintRuleId: [
                    {
                        required: true,
                        message: "请选择关联规则",
                        trigger: "blur"
                    }
                ],
                goodsCategorys: [
                    {
                        type: "array",
                        required: true,
                        message: "请选择打印商品",
                        trigger: "blur"
                    }
                ],
                printDevices: [
                    {
                        type: "array",
                        required: true,
                        message: "请选择打印设备",
                        trigger: "blur"
                    }
                ]
            },
            classifyList: [
                {
                    value: "0",
                    label: "全选",
                    children: []
                }
            ],
            printSplit: false,
            isSubmit: false
        };
    },
    computed: {
        ...mapState({
            shop: state => state.shopInfo
        })
    },
    watch: {
        activeName(val) {
            this.$router.push({
                path: this.pathList[val].path
            });
        }
    },
    mounted() {
        this.getPageData();
    },
    methods: {
        getPageData() {
            this.getPrintRules(1);
            getCountPrintRules({
                printType: 2
            }).then(res => {
                if (res.code == 1) {
                    this.count = res.data;
                }
            });
            getShopInfo().then(res => {
                if (res.code == 1) {
                    this.printSplit = res.data.printType == 2 ? true : false;
                }
            });
        },
        async addPrinter() {
            await getPrinterDevices().then(res => {
                if (res.code == 1) {
                    this.printerDeviceList = res.data;
                }
            });
            await getEdcShopGoodsCategorys().then(res => {
                if (res.code == 1) {
                    let list = [];
                    res.data.forEach((val, index) => {
                        list[index] = {};
                        list[index].value = val.goodsCategoryId;
                        list[index].label = val.categoryName;
                    });
                    this.classifyList[0].children = list;
                }
            });
            await getPrintRules({
                pageNo: 1,
                row: 1000,
                printType: 1
            }).then(res => {
                if (res.code == 1) {
                    this.templateList = res.data;
                }
            });
            this.dialogAddRuleVisible = true;
        },
        tabsChange(val) {},
        handleSizeChange(e) {
            console.log(e);
        },
        handleCurrentChange(e) {
            this.getPrintRules(e);
        },
        getPrintRules(pageNo) {
            getPrintRules({
                pageNo: pageNo,
                row: 5,
                printType: 2
            }).then(res => {
                if (res.code == 1) {
                    this.printRuleList = res.data;
                }
                if (res.code == -1) {
                    this.printRuleList = [];
                }
                this.isListLoad = false;
            });
        },
        del(id) {
            this.$msgbox({
                title: "消息",
                message: `是否删除，删除后将无法恢复！`,
                showCancelButton: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        delPrintRule({
                            printRuleId: id
                        }).then(res => {
                            if (res.code == 1) {
                                this.$notify({
                                    title: "提示",
                                    message: "删除成功",
                                    type: "success"
                                });
                                this.getPageData();
                            } else {
                                this.$notify({
                                    title: "提示",
                                    message: res.msg,
                                    type: "error",
                                    duration: 2000
                                });
                            }
                        });
                        done();
                    } else {
                        done();
                    }
                }
            }).then(action => {});
        },
        edit(index) {
            this.addRuleForm = JSON.parse(
                JSON.stringify(this.printRuleList[index])
            );
            this.addRuleForm.printDevices = this.addRuleForm.printDevices.split(
                ","
            );
            this.addRuleForm.goodsCategorys = this.addRuleForm.goodsCategorys.split(
                ","
            );
            this.addRuleForm.printDevices.forEach((val, index) => {
                this.addRuleForm.printDevices[index] = Number(val);
            });
            this.addRuleForm.goodsCategorys.forEach((val, index) => {
                this.addRuleForm.goodsCategorys[index] = ["0", Number(val)];
            });
            this.addPrinter();
        },
        save() {
            this.$refs.addRuleForm.validate(valid => {
                if (valid) {
                    this.isSubmit = true;
                    let Param = Object.assign({}, this.addRuleForm);
                    Param.printDevices = this.addRuleForm.printDevices.join(
                        ","
                    );
                    Param.goodsCategorys = "";
                    this.addRuleForm.goodsCategorys.forEach((val, index) => {
                        if (
                            this.addRuleForm.goodsCategorys.length ==
                            index + 1
                        ) {
                            Param.goodsCategorys += val[1];
                        } else {
                            Param.goodsCategorys += `${val[1]},`;
                        }
                    });
                    savePrintRule(Param).then(res => {
                        if (res.code == 1) {
                            this.$notify({
                                title: "提示",
                                message: "创建成功",
                                type: "success",
                                duration: 2000
                            });
                            this.getPageData();
                            this.dialogAddRuleVisible = false;
                        } else {
                            this.$notify({
                                title: "提示",
                                message: res.msg,
                                type: "error",
                                duration: 2000
                            });
                        }
                        setTimeout(() => {
                            this.isSubmit = false;
                        }, 500);
                    });
                } else {
                    this.$notify({
                        title: "提示",
                        message: "请完善提交内容",
                        type: "error",
                        duration: 2000
                    });
                    return false;
                }
            });
        },
        addRuleDialogClose() {
            this.addRuleForm = {
                relationPrintRuleId: "",
                printRuleName: "",
                goodsCategorys: [],
                printDevices: [],
                printType: 2,
                printPageNum: 1,
                printStage: 1
            };
        },
        modifyPrintSplit(val) {
            toSetPrintType({
                printType: val ? 2 : 1
            });
        }
    }
};
</script>

<style lang="less" scoped>
.content-page {
    .tab-content {
        display: block;
        padding: 20px;
    }
    .tab-header {
        .switch-container {
            cursor: pointer;
            line-height: 32px;
            margin-left: 10px;
            span {
                font-size: 14px;
                margin-right: 10px;
            }
        }
    }
    .el-dialog {
        .el-select {
            width: 100%;
        }
        .dialog-title {
            font-weight: bold;
        }
        .ruleForm-bottom {
            margin-top: 20px;
        }
    }
}
.el-cascader {
    width: 100%;
}
</style>